export { default } from './SingleAnswerScreen';
